export default "__VITE_ASSET__NS4amJI5XMLopbo2BwYNHA__"